/* eslint-disable */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '@/store/actions/auth'
// import { USER_REQUEST } from '../actions/user'
import { exec } from '@/api'

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  hasLoadedOnce: false,
  userEmail: localStorage.getItem('user-email') || '',
  userName: localStorage.getItem('user-name') || '',
  userId: localStorage.getItem('user-id') || '',
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  userEmail: state => state.userEmail,
  token: state => state.token,
  userName: state => state.userName,
  userId: state => state.userId
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise(async (resolve, reject) => {
      commit(AUTH_REQUEST)
      var valid = await exec.isValid(user)
      if (valid.authenticated) {
        localStorage.setItem('user-token', valid.token)
        localStorage.setItem('user-email', valid.email)
        localStorage.setItem('user-id', valid.user_id)
        localStorage.setItem('user-name', valid.first_name)
        commit(AUTH_SUCCESS, valid)
        resolve(true)
      } else {
        commit(AUTH_ERROR, 'err')
        console.log('login error')
        localStorage.removeItem('user-token')
        resolve(false)
      }
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      console.log('AUTH_LOGOUT')
      localStorage.removeItem('user-token')
      localStorage.removeItem('user-email')
      localStorage.removeItem('user-name')
      localStorage.removeItem('user-id')
      state.token = ''
      state.loggedIn = false
      state.userEmail = null
      state.userName = ''
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.loggedIn = true
    state.token = localStorage.getItem('user-token')
    state.userEmail = localStorage.getItem('user-email')
    state.userName = localStorage.getItem('user-name')
    state.userId = localStorage.getItem('user-id')
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    console.log('AUTH_LOGOUT2')
    state.token = ''
    state.loggedIn = false
    state.userEmail = null
    state.userName = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js